import _asyncToGenerator from "/root/steemboylikegirlClub/gitproject/steemboylikegirlclub/steemboylikegirlclub/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.function.name.js";
import "regenerator-runtime/runtime.js";
import { extractLoginData, getAccount } from "../unit/UserUtil";
import { uploadImage } from "../unit/UploadImage";
import { $t } from "../plugins/i18n";
import { ElMessage, ElLoading } from "element-plus";
import { existsEmailOrUserName, sendVerifyEmail } from "../apis/services/steemActivity";
import dsteem from "../unit/DsteemUtil";
export default {
  components: {},
  data: function data() {
    var _this = this;

    var validateUserName = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this.userName === "")) {
                  _context.next = 4;
                  break;
                }

                callback(new Error(_this.$t("error.haveNullUser")));
                _context.next = 8;
                break;

              case 4:
                _context.next = 6;
                return _this.verifyUserName();

              case 6:
                if (!_this.isVerify) {
                  callback(new Error(_this.$t("error.userNameExist")));
                }

                callback();

              case 8:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }));

      return function validateUserName(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }();

    var validateEmail = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(rule, value, callback) {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                if (!(_this.email === "")) {
                  _context2.next = 4;
                  break;
                }

                callback(new Error(_this.$t("error.haveNullEmail")));
                _context2.next = 8;
                break;

              case 4:
                _context2.next = 6;
                return _this.verifyEmail();

              case 6:
                if (!_this.isVerifyEmail) {
                  callback(new Error(_this.$t("error.emailExist")));
                }

                callback();

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }));

      return function validateEmail(_x4, _x5, _x6) {
        return _ref2.apply(this, arguments);
      };
    }();

    return {
      loginData: null,
      saveLoad: false,
      userName: "",
      email: "",
      isVerify: false,
      isVerifyEmail: false,
      isSendEmail: false,
      rules: {
        userName: [{
          validator: validateUserName,
          trigger: "blur"
        }],
        email: [{
          validator: validateEmail,
          trigger: "blur"
        }]
      }
    };
  },
  methods: {
    verifyUserName: function verifyUserName() {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var account;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return getAccount(_this2.userName);

              case 2:
                account = _context3.sent;

                if (account.name) {
                  _this2.isVerify = false;
                } else {
                  _this2.isVerify = true;
                }

              case 4:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    verifyEmail: function verifyEmail() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var data, result;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                data = {
                  email: _this3.email
                };
                _context4.next = 3;
                return existsEmailOrUserName(data);

              case 3:
                result = _context4.sent;

                if (result.data) {
                  _this3.isVerifyEmail = false;
                } else {
                  _this3.isVerifyEmail = true;
                }

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    },
    onSave: function onSave() {
      var _this4 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var data, result;
        return regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _this4.saveLoad = true;
                data = {
                  email: _this4.email,
                  userName: _this4.userName
                };
                _context5.next = 4;
                return sendVerifyEmail(data);

              case 4:
                result = _context5.sent;

                if (result.data) {
                  _this4.isSendEmail = true;
                } else {
                  ElMessage.error(_this4.$t("error." + result.message));
                }

                _this4.saveLoad = false;

              case 7:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }))();
    }
  },
  mounted: function mounted() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee6() {
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }))();
  }
};